<template>
    <div>
        <v-form class="pa-2" @submit.prevent="handleStudiengangUpload">
            <file-input-field
                v-model="file"
                accept=".csv"
                placeholder="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Studiengängen hier rein..."
                label="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Studiengängen hier rein..."
                data-test="input-upload-studiengang"
                :violation-fields="['fileData']"
                :error="error"
                :is-loading="isLoading"
                :disabled="studiengangUploadState === null"
            />
            <v-btn
                type="submit"
                block
                color="primary"
                variant="tonal"
                data-test="button-upload-studiengang"
                :disabled="!studiengangUploadState || isLoading"
            >
                Studiengangimport starten
            </v-btn>
            <global-form-error :error="globalErrors" :is-html="true" />
            <success-alert :show="isFinished" message="Studiengang erfolgreich importiert." />
            <info-alert :show="true">
                <b>Hinweis:</b>
                <ul class="mb-0">
                    <li>Vor dem Import müssen die Fakultäten vorhanden sein.</li>
                    <li>Bei einer fehlerhaften csv-Datei werden keine Studiengänge importiert.</li>
                    <li>
                        Import-Fehler werden hier angezeigt sowie im Import-Logfile gespeichert.
                    </li>
                </ul>
            </info-alert>
        </v-form>
    </div>
</template>

<script setup>
    import { computed, onMounted, ref } from 'vue'
    import { getViolationsFeedback, useUploadFile } from '@/js/utils'
    import {
        FileInputField,
        GlobalFormError,
        InfoAlert,
        SuccessAlert
    } from '@/js/components/Common'
    import { useStudiengangStore } from '@/js/stores'

    const studiengangStore = useStudiengangStore()
    const { file, readFileAsUrl } = useUploadFile()
    const isFinished = ref(false)

    onMounted(() => {
        isFinished.value = false
    })

    const studiengangUploadState = computed(() => {
        if (null === file.value) return
        return Boolean(file.value)
    })
    const isLoading = computed(() => studiengangStore.isLoading)
    const error = computed(() => studiengangStore.getError('upload-studiengang'))
    const globalErrors = computed(() =>
        getViolationsFeedback(['fileData'], error.value?.errorData, true)
    )

    async function handleStudiengangUpload() {
        isFinished.value = await studiengangStore.uploadStudiengangFile(await readFileAsUrl())
    }
</script>

<style scoped></style>
